import axios from 'axios';
import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import { addOrganization } from '../../AddOrganization/api';

const API_ROOT = '/api/v1/accounts/';

interface TransferSite {
  accountId: number;
  siteId: number;
  organizationId: number;
}

export async function transferSite({
  accountId,
  siteId,
  organizationId,
}: TransferSite): Promise<ApiBaseResponse> {
  const response = await axios.put<ApiBaseResponse>(`${API_ROOT}${accountId}/sites/${siteId}`, {
    organization_id: organizationId,
  });

  if (!response.data.success) {
    throw new Error();
  }

  return response.data;
}

interface CreateOrgAndTransferSite {
  accountId: number;
  siteId: number;
  organizationName: string;
}

export async function createOrgAndTransferSite({
  accountId,
  siteId,
  organizationName,
}: CreateOrgAndTransferSite): Promise<ApiBaseResponse> {
  const response = await addOrganization(accountId, organizationName);

  return transferSite({ accountId, organizationId: response.organization.id, siteId });
}
